<template>
    <div id="leo_search_block_top" class="block exclusive search-by-category">
        <h4 class="title_block">
            Search here...
        </h4>
        <div action="javascript:void(0)"
            id="leosearchtopbox" data-label-suggestion="Suggestion" data-search-for="Search for"
            data-in-category="in category" data-products-for="Products For" data-label-products="Products"
            data-view-all="View all">
            <div class="block_content clearfix leoproductsearch-content">
                <div class="list-cate-wrapper">
                    
                    <a href="javascript:void(0)" id="dropdownListCateTop" class="select-title" rel="nofollow"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                        @click.prevent="showCategories = !showCategories" v-click-outside="onOutsideClick">
                        <span>{{ currentCategory }}</span>
                        <i class="material-icons pull-xs-right">keyboard_arrow_down</i>
                    </a>
                    <div class="list-cate dropdown-menu" aria-labelledby="dropdownListCateTop"
                        :class="{ 'menu-show': showCategories }" ref="dropdownMenu">
                        <a 
                            href="#" 
                            data-cate-id data-cate-name="All Categories" 
                            @click.prevent="currentCategory = 'All Categories'" 
                            class="cate-item active"
                        >
                            All Categories
                        </a>
                        <a 
                            v-for="(cate, i) in categories" 
                            href="javascript:void(0)" 
                            :key="i"
                            :data-cate-id="i + 2" :data-cate-name="cate.name"
                            class="cate-item cate-level-1"
                            @click.prevent="getCategory(cate)"
                        >{{ cate.name }}</a>
                    </div>
                </div>
                <div class="leoproductsearch-result">
                    <div class="leoproductsearch-loading cssload-speeding-wheel"></div>
                    <input v-model="query" @keyup.enter.prevent="gotoResultPage" class="search_query form-control grey"
                        type="text" id="leo_search_query_top" name="search_query" data-content='["search products..."]'
                        value placeholder="Search" />
                    <div class="ac_results lps_results"></div>
                </div>
                <button type="submit" id="leo_search_top_button" class="btn btn-default button button-small">
                    <span><i class="material-icons search" @click.prevent="gotoResultPage">Search</i></span>
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
// import { useCategoryStore } from "@/stores/category-store";
import { useCommonStore } from "@/stores/common.store";

const router = useRouter();

const emit = defineEmits(['hide-nav']);

const query = ref("");
const showSearchInput = ref(false);
const showCategories = ref(false);
const currentCategory = ref("All Categories");
const currentCategoryId = ref(null);
const currentCategoryObj = ref(null);
const dropdownMenu = ref(null);

// const categoryStore = useCategoryStore();
const commonStore = useCommonStore();

const categories = computed(() => commonStore.categories ?? []);

const gotoResultPage = () => {
    if (query.value?.length){
        let qv = query.value.length ? query.value : '';
        // let cateName = currentCategory.value != "All Categories" ? currentCategory.value : "";
        let cateId = currentCategory.value != "All Categories" ? currentCategoryObj.value.id : "";
        let queryVal = { query: qv };
        // if (cateName?.length) queryVal.category = cateName;
        if (cateId.length) queryVal.categoryId = cateId;
        
        router.push({
            name: "products",
            query: queryVal,
        });


        /** FOR ENCODE URL */
        // let queryVal = {
        //     query: encodeURIComponent(qv),
        //     categoryName: encodeURIComponent(cateName)
        // };
        // Create the query string
        // let queryString = `query=${qv}&categoryName=${cateName}`;
        
        // // Base64 encode the query string
        // let encodedString = btoa(queryString);

        // // Push the encoded string as a single query parameter
        // router.push({
        //     name: "shop",
        //     query: {
        //         data: encodedString
        //     },
        // });
        
        emit('hide-nav')
    } 
    
    // else {
    //     showSearchInput.value = !showSearchInput.value
    // }
    
    query.value = "";
    
};

// const gotoResultPage = () => {
//     let qv = ''
//     let cate = ''
//     if (query.value && query.value.length > 0){
//         qv = query.value
//     } else {
//         qv = 'emptyQuery';
//     }
//     if (input.value && input.value != 'none'){
//         cate = input.value
//     } else {
//         cate = '';
//     }
//     if (qv != 'emptyQuery' ) {
//         router.push({
//             name: "ProductList",
//             query: {
//                 query: qv,
//                 categoryId: cate,
//             },
//         });
//     }
//     // query.value = "";
//     // input.value = "none";
//     // emit('hide-nav')
// };

const getCategory = (val) => {
    // if (dropdownMenu.value) {
    //     dropdownMenu.value.addEventListener('click', (val) => {
    //       const target = val.target;
    //       if (target.tagName === 'A' && target.classList.contains('cate-item')) {
    //         console.log(target.innerHTML.trim());
    //         currentCategory.value = target.innerHTML.trim();
    //         val.preventDefault(); // If you want to prevent the default link behavior
    //       }
    //     });
    //   }
    currentCategoryObj.value = val
    currentCategoryId.value = val.id;
    currentCategory.value = val.name;
}

const onOutsideClick = () => {
    showSearchInput.value = false
    showCategories.value = false;
};

const fetchCategories = async () => {
    await commonStore.fetchCategories();
};

onMounted(() => {
  fetchCategories();  
})
</script>

<style lang="scss">
.search-input[type=text]:focus {
    background-color: #F6F7F8;
}

.bg-input {
    background-color: #F6F7F8;
}

.menu-show {
    display: block !important
}
</style>
